import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormValidationModule } from './components/form-validation/form-validation.module';
import { StatusChipModule } from './components/status-chip/status-chip.module';
import { ToggleButtonModule } from './components/toggle-button/toggle-button.module';
import { IconsModule } from './design/icons.module';
import { TooltipModule } from './directives/tooltip/tooltip.module';
import { PaginationModule } from './components/pagination/pagination.module';
import { InlineConfirmModule } from './components/inline-confirm/inline-confirm.module';
import { InlinePanelModule } from './components/inline-panel/inline-panel.module';
import { TabsModule } from './components/tabs/tabs.module';
import { KpiModule } from './components/kpi/kpi.module';
import { WidgetHeaderModule } from './components/widget-header/widget-header.module';
import { CashierSummaryModule } from './components/cashier-summary/cashier-summary.module';
import { ChartFrameModule } from './components/chart-frame/chart-frame.module';
import { DialogModule } from './components/dialog/dialog.module';
import { FiltersCollapseModule } from './components/filters-collapse/filters-collapse.module';
import { EmptyStateModule } from './components/empty-state/empty-state.module';
import { SkeletonModule } from './components/skeleton/skeleton.module';
import { ActionMenuModule } from './components/action-menu/action-menu.module';
import { ViewToggleModule } from './components/view-toggle/view-toggle.module';
import { DataTableModule } from './components/data-table/data-table.module';
import { CopyModule } from './directives/copy/copy.module';
import { FileDropModule } from './components/file-drop/file-drop.module';
import { FilePickerModule } from './components/file-picker/file-picker.module';
import { LoadingContentModule } from './directives/loading-content/loading-content.module';
import { TabsSliderModule } from './components/tabs-slider/tabs-slider.module';
import { PageHeaderModule } from './components/page-header/page-header.module';
import { TableExportModule } from './components/table-export/table-export.module';

@NgModule({
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormValidationModule,
    StatusChipModule,
    ToggleButtonModule,
    IconsModule,
    TooltipModule,
    PaginationModule,
    InlineConfirmModule,
    InlinePanelModule,
    TabsModule,
    TabsSliderModule,
    KpiModule,
    WidgetHeaderModule,
    EmptyStateModule,
    ChartFrameModule,
    DialogModule,
    FiltersCollapseModule,
    CashierSummaryModule,
    SkeletonModule,
    LoadingContentModule,
    FileDropModule,
    FilePickerModule,
    ActionMenuModule,
    ViewToggleModule,
    CopyModule,
    DataTableModule,
    PageHeaderModule,
    TableExportModule
  ]
})
export class SharedModule { }
